import { Component, OnInit } from '@angular/core'
import { GeneralService } from 'src/app/services/general/general.service'

@Component({
  selector: 'app-install',
  template: `
    <screen-container>
      <div class="container install-container">
        <div class="store-button" appLink log-id="app_install">타입스 앱 설치하러 가기</div>
      </div>
    </screen-container>
  `,
  styles: [
    `
      .install-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .store-button {
        padding: 20px;
        border-radius: 20px;
        text-align: center;
        background-color: var(--black);
        color: #fff;
      }
    `,
  ],
})
export class InstallComponent implements OnInit {
  constructor(private generalService: GeneralService) {}

  ngOnInit() {
    const storeNavigationTimeout = setTimeout(() => {
      this.navigateToStore()
      clearTimeout(storeNavigationTimeout)
    }, 5000)
  }

  navigateToStore(): void {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    // Check if the user agent string contains 'iPhone' or 'iPad'
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    // Check if the user agent string contains 'Android'
    const isAndroid = /Android/i.test(navigator.userAgent)
    if (isMobile) {
      if (isAndroid) {
        this.generalService.openInappBrowser('market://details?id=com.woot.types')
      } else {
        this.generalService.openInappBrowser('itms-apps://itunes.apple.com/app/id1596043031')
      }
    } else {
      if (isAndroid) {
        this.generalService.openInappBrowser('https://play.google.com/store/apps/details?id=com.woot.types')
      } else {
        this.generalService.openInappBrowser('https://itunes.apple.com/kr/app/id1596043031')
      }
    }
  }
}
